<template>
  <div>
    <v-layout wrap>
      <v-flex >
        <c-search-form
            :rows-per-page-items="[10, 20, 50]"
            :form-name="formName"
            :fields="fields"
            :hiddenFields="hiddenFields"
            model="searchForm"
            key-property="accountId"
            :search-url="searchUrl"
            delete-url="/kidAccountClass/deleteLogMoveClass"
            form-type="intable"
            custom-create-new
            @createNew="openCreateDialog"
            custom-edit-item
            @editItem="openCreateDialog"
            custom-class-item
            @classItem="openClassDialog"
            ref="tableData"
            :reload="timeReload"
            :deleteMulti="false"
            orderBy="desc"
            :acceptDelete="true"
            :acceptView="false"
            :accept-edit="false"
            :accept-create="false"
            :acceptLogModeClass = "false"
            @viewItem="viewItem"
            :accept-back="9"
        >
        </c-search-form>
        <material-type-group-create
            :propsItem="category"
            :cDialog="visibleCreateDialog"
            @closeCreateDialog="closeCreateDialog"
            :formCreateName="formCreateName"
            :hiddenFields="hiddenFields"
        />
      </v-flex>
    </v-layout>
  </div>

</template>

<script>
import CSearchForm from "../../../components/form/ManageForm";
import {areaContants} from "@/constants";
import axios from "axios";
import MaterialTypeGroupCreate from "@/views/admin/account_class/AccountClassCreate";

export default {
  name: "warehouse",
  components: {MaterialTypeGroupCreate, CSearchForm},
  data: () => {
    return {
      formName: "Thông tin log học sinh chuyển lớp",
      formCreateName: "Thêm mới học sinh",
      className: null,
      category: null,
      visibleCreateDialog: false,
      timeReload: 0,
      searchUrl:null,
      accountId:null,
      allAcount: 0,
      hiddenFields: {
        typeId: "0",
      },
      fields: [
        {
          value: "index",
          text: "lang.common.index",
          sortable: false,
          headerStyle: "text-align:center; width: 40px;",
        },
        {
          value: 'accountId',
          text: 'AccountID',
          sortable: false,
          search: false,
          headerStyle: "text-align:center; width: 50px;",
        },
        {
          value: 'dateMove',
          text: 'Ngày chuyển lớp',
          dateFormat: 'dd/MM/yyyy',
          sortable: false,
          search: false,
          headerStyle: "text-align:center; width: 100px;",
        },
        {
          type: "select",
          name: "moveType",
          value: 'moveType',
          text: 'Trạng thái chuyển lớp',
          sortable: false,
          search: false,
          headerStyle: "text-align:center ;width: 130px;",
          itemText: "status",
          itemValue: "value",
          items: [
            {value: 1, status: 'Nhanh tiến độ'},
            {value: 2, status: 'Chậm tiến độ'}
          ],
        },
        {
          value: 'oldClassName',
          text: 'Tên lớp cũ',
          sortable: false,
          search: false,
          headerStyle: "text-align:center; width: 150px;",
        },
        {
          value: 'newClassName',
          text: 'Tên lớp mới',
          sortable: false,
          search: false,
          headerStyle: "text-align:center; width: 150px;",
        },
        {
          value: "action",
          text: "lang.common.actions",
          sortable: false,
          compound: true,
          width: "10%",
          headerStyle: "text-align:center",
        },
      ],
    };
  },

  created() {
    this.searchUrl = "/kidAccountClass/searchLogByAccountId/" + this.$route.params.id + "?sortField=status,accountId&";
    axios.post(
        process.env.VUE_APP_API_URL + "/kidClass/listAllName", {status: 1}
    )
        .then(
            (data) => {
              let itemFields = this.fields.filter(function (e) {
                return e.name == "classId";
              });
              if (itemFields != undefined && itemFields.length > 0) {
                itemFields[0].items = data;
              }
            }
        );
  },



  methods: {
    clearFromDate() {
      this.hiddenFields.fromDate = null;
    },
    clearToDate() {
      this.hiddenFields.toDate = null;
    },
    onChangeFromDate(date) {
      this.hiddenFields.fromDate = date;
    },
    onChangeToDate(date) {
      this.hiddenFields.toDate = date;
    },
    openCreateDialog: function (item = null) {
      if (item == null) {
        this.formCreateName = 'Thêm mới học sinh';
        this.getNextCode();
      } else {
        this.category = item;
        this.formCreateName = 'Cập nhật học sinh';
        this.visibleCreateDialog = true;
      }
    },
    openClassDialog: function (item = null) {
        this.category = item;
        this.formCreateName = 'Chuyển lớp';
        this.visibleCreateDialog = true;
    },
    closeCreateDialog: function () {
      this.category = null;
      this.visibleCreateDialog = false;
      this.timeReload = Math.floor(Math.random() * 100);
    },

    getNextCode: function () {
      axios.get(
          process.env.VUE_APP_API_URL +
          "/autoIncrease/getNextNumber?type=MATERIAL_TYPE_ALLY"
      )
          .then((data) => {
            this.category = Object.assign({}, this.category, {"categoryCode": "MATERIAL_TYPE_ALLY" + data, "status": 1})
            this.visibleCreateDialog = true;
          });
    },

    createParamLastSearch: function (values) {
      const obj1 = {
        searchImportRequest: JSON.stringify(values),
      };
      /*const obj2 = this.$route.query;*/
      const obj2 = this.$route.query;
      return {...obj1, ...obj2};
    },
    viewItem: function (item) {
      this.$router.push({
        path: '/accountDetail/view/' + item.accountId,
        //path: '/accountDetail/view/' + item.accountId,
        query: this.createParamLastSearch(this.lastSearchValues)
      });
    },
  },

  destroyed() {
  },
};
</script>
